import React, {forwardRef, PropsWithChildren} from "react";
import classNames from "classnames";
import style from './TagList.module.scss';

type TagListProps = {
    className?: string;
}

export const TagList = forwardRef<HTMLDivElement, PropsWithChildren<TagListProps>>(({className, children}, ref) => {
    return (
        <div ref={ref} className={classNames(className, style.tagList)}>
            {children}
        </div>
    );
})
